import { ReactComponent as CloseIcon } from '../../assets/close.svg';
import React from 'react';
import classNames from 'classnames';

export interface BannerProps {
  prefix?: JSX.Element;
  className?: string;
  children?: JSX.Element | JSX.Element[] | string | boolean;
  onClose?: () => void;
}
export default function Banner({ prefix, children, className, onClose }: BannerProps) {
  return (
    <div className={classNames('banner', className)}>
      {prefix && <span className="banner__prefix">{prefix}</span>}
      <span className="banner__content">{children}</span>
      {onClose && <CloseIcon role="button" onClick={onClose} className="icon banner__close" />}
    </div>
  );
}
